import { render, staticRenderFns } from "./CopyLinkedTextsSelector.vue?vue&type=template&id=8968efd0&"
import script from "./CopyLinkedTextsSelector.vue?vue&type=script&lang=ts&"
export * from "./CopyLinkedTextsSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports